import { render, staticRenderFns } from "./ChangeLanguage.vue?vue&type=template&id=bfd496f8&scoped=true&"
import script from "./ChangeLanguage.vue?vue&type=script&lang=js&"
export * from "./ChangeLanguage.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLanguage.vue?vue&type=style&index=0&id=bfd496f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd496f8",
  null
  
)

export default component.exports